import { atom } from "recoil";

export const layerMenuIsHiddenState = atom({
  key: "layerMenu/layerMenuToggleState",
  default: true,
});